module.exports = __webpack_public_path__ + "img/accounting-coins-bill.26875f7b.svg";